import http from '../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/demo/bscOrderXietong',

    // 查询
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscOrderXietong/selectPage',
            method: 'post',
            params: query
        });
    },
    // 提交审批
    saveOrUpdateXietong(query) {
        return http({
            url: '/api/swyl/v1/demo/bscOrderXietong/saveOrUpdateXietong',
            method: 'post',
            params: query
        });
    },
    // 审批通过或驳回
    shenpiPass(query) {
        return http({
            url: '/api/swyl/v1/demo/bscOrderXietong/shenpiPass',
            method: 'post',
            params: query
        });
    },
    // 删除或者恢复
    delOrRes(query) {
        return http({
            url: '/api/swyl/v1/demo/bscOrderXietong/delOrRes',
            method: 'post',
            params: query
        });
    },
}